<template>
    <section class="c-case-study">
        <div class="c-case-study__heading">
            <div class="c-case-study__title">
                <component
                    :is="titleTag || 'h2'"
                >
                    {{ caseStudiesData.title || $t('mvp.case_studies_title') }}
                </component>
            </div>
            <div
                v-if="caseStudiesData.synopsis"
                class="c-case-study__synopsis"
            >
                <p>
                    {{ caseStudiesData.synopsis }}
                </p>
            </div>
        </div>
        <div class="c-case-study__content">
            <ul
                class="case-study-list"
                :class="{'single-case-card': (caseStudiesData.albums.length === 1) && isDesktop }"
            >
                <li
                    v-for="item in caseStudiesData.albums"
                    :key="item.id"
                    class="list-item"
                >
                    <component
                        :is="((caseStudiesData.albums.length === 1) && isDesktop)?'div':'router-link'"
                        :to="{
                            name: 'case-study-single',
                            params: {slug: item.slug}
                        }"
                        class="link-item"
                    >
                        <div
                            class="list-item__image-container flex-same-width"
                            :class="{'two-card-img': (caseStudiesData.albums.length === 2) && isDesktop}"
                        >
                            <img
                                :src="imgSrc(item, 'main1')"
                                :alt="item.title"
                                class="case-study-img"
                            >
                        </div>
                        <div class="list-item__content flex-same-width">
                            <h3 class="content-title">
                                {{ item.title }}
                            </h3>

                            <p class="content-description">
                                {{ item.description }}
                            </p>
                            <y-button
                                v-if="(caseStudiesData.albums.length === 1) && isDesktop"
                                tag="router-link"
                                :to="{name: 'case-study-single', params:{slug:item.slug}}"
                                :content="$t('case-studies.button_case')"
                                color="primary"
                                size="medium"
                                flat
                                :no-padding="true"
                            />
                        </div>
                    </component>
                </li>
            </ul>
        </div>
        <div
            v-if="caseStudiesData.custom && caseStudiesData.custom['button-link'] && caseStudiesData.custom['button-title']"
            class="c-case-study__action"
        >
            <y-button
                color="transparent"
                :tag="isLink(caseStudiesData.custom['button-link']) ? 'a' : 'router-link'"
                :to="caseStudiesData.custom['button-link']"
                :href="caseStudiesData.custom['button-link']"
                :content="caseStudiesData.custom['button-title']"
                size="normal"
                flat
                :no-padding="true"
            />
        </div>
    </section>
</template>

<script >

    import { isLink } from '@/helpers/helpers';

    export default {
        name : 'CaseStudyComponent',
        props: {
            caseStudiesData: {
                type    : Object,
                required: true,
            },
            titleTag: String,
        },
        computed: {
            /**
             *
             * Whether the device is desktop or not
             *
             * @returns {boolean}
             */
            isDesktop() {
                return this.$mq === 'lg' || this.$mq === 'xlg';
            },
        },
        /**
         *
         * @inheritDoc
         */
        methods: {
            isLink,
        },

    };

</script>

<style lang="scss" src="./case-study.scss"/>
